import React from "react";
import bannerImg from "../../images/home_banner.jpg";
import bodyImg1 from "../../images/home_body1.jpg";
import bodyImg2 from "../../images/home_body2.jpg";
import "./Home.css";

const ServiceIcons = {
  personal: (
    <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20Z" stroke="#F44336" strokeWidth="2.5"/><path d="M24 34v-2.5M24 29.5c-2.5 0-4-1.5-4-4 0-2.5 1.5-4 4-4s4 1.5 4 4c0 2.5-1.5 4-4 4Z" stroke="#F44336" strokeWidth="2.5" strokeLinecap="round"/><path d="M24 14v2.5" stroke="#F44336" strokeWidth="2.5" strokeLinecap="round"/></g></svg>
  ),
  investment: (
    <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><g><rect x="8" y="12" width="32" height="24" rx="4" stroke="#00BFAE" strokeWidth="2.5"/><path d="M16 20h16M16 24h8" stroke="#00BFAE" strokeWidth="2.5" strokeLinecap="round"/></g></svg>
  ),
  business: (
    <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><g><circle cx="24" cy="24" r="20" stroke="#FFC107" strokeWidth="2.5"/><path d="M24 14v10l7 7" stroke="#FFC107" strokeWidth="2.5" strokeLinecap="round"/></g></svg>
  )
};

const Home = () => (
  <div className="home-root">
    <section className="home-banner-fixed">
      <img src={bannerImg} alt="Naman Finlease Banner" className="banner-img" />
    </section>
    <section className="intro-section">
      <div className="intro-content">
        <h2>Welcome to Naman Finlease Pvt. Ltd</h2>
        <p>
          Naman Finlease Pvt. Ltd is a leading NBFC dedicated to providing innovative and accessible financial solutions. Our mission is to empower individuals and businesses with the resources they need to achieve their financial goals, through trust, transparency, and customer-centric service.
        </p>
      </div>
    </section>
    {/* <section className="intro-image-section">
      <img src={bodyImg1} alt="Naman Finlease Team" className="intro-image" />
    </section> */}
    <section className="home-feature-section">
      <div className="feature-content">
        <h2>About Us</h2>
        <p>
          Naman Finlease Pvt. Ltd is a promising Fintech company and registered NBFC. With a team of experienced professionals in the financial industry, we offer a wide range of financial services to our clients, including loans, investments, insurance, and more. Our goal is to provide affordable and accessible financial services to individuals and businesses, especially those who are underserved by traditional financial institutions. We believe that financial inclusion is key to economic growth and stability, and we are committed to helping our clients achieve their financial goals.
        </p>
        <ul className="feature-list">
          <li>Secured Data System</li>
          <li>Customized Personal Loans</li>
          <li>Instant Approval & Disbursal</li>
        </ul>
      </div>
      <div className="feature-image">
        <img src={bodyImg1} alt="Naman Finlease Team" />
      </div>
    </section>
    <section className="home-feature-section reverse">
      <div className="feature-image">
        <img src={bodyImg2} alt="Disclaimer Visual" />
      </div>
      <div className="feature-content">
        <h2>Disclaimer</h2>
        <p>
          No information contained herein has been independently verified by anyone else. The contents of this presentation are confidential and may not be copied, distributed, redistributed or disseminated, directly or indirectly, in any manner, without the prior written consent of the Company. Unauthorised use or dissemination of the information is strictly prohibited.<br/><br/>
          The NBFC does not make any guarantees, express or implied, regarding completeness, accuracy, or reliability of the information provided hereunder. The Presenter and Company disclaim any liability for errors, omissions or inaccuracies or any decisions made by participants based on the content presented.
        </p>
      </div>
    </section>
    <section className="our-services-section">
      <h2 className="our-services-title">Our Services</h2>
      <div className="our-services-grid">
        <div className="our-service-card">
          <div className="service-icon">{ServiceIcons.personal}</div>
          <h3>Personal Loans</h3>
          <p>We offer customized personal loans to meet your specific financial requirements, such as home renovation, education, medical expenses, or debt consolidation.</p>
        </div>
        <div className="our-service-card">
          <div className="service-icon">{ServiceIcons.investment}</div>
          <h3>Investment Services</h3>
          <p>We offer a wide range of investment options, including mutual funds, stocks, bonds, and more, to help you grow your wealth and achieve your financial goals.</p>
        </div>
        <div className="our-service-card">
          <div className="service-icon">{ServiceIcons.business}</div>
          <h3>Business Loans</h3>
          <p>We provide business loans to small and medium enterprises (SMEs) to help them expand their operations, purchase new equipment, or fund their working capital requirements.</p>
        </div>
      </div>
    </section>
    <section className="why-choose-section">
      <h2 className="why-choose-title">Why Choose Naman Finlease?</h2>
      <div className="why-choose-grid">
        <div className="why-choose-card">
          <h3>Customer-Centric Approach</h3>
          <p>We prioritize our clients' needs and provide personalized solutions to help them achieve their financial goals.</p>
        </div>
        <div className="why-choose-card">
          <h3>Experienced Team</h3>
          <p>Our team of financial experts has years of experience in the financial industry and is committed to providing quality financial services to our clients.</p>
        </div>
        <div className="why-choose-card">
          <h3>Affordable Services</h3>
          <p>We offer affordable financial services to ensure that everyone has access to the financial tools they need to achieve their dreams.</p>
        </div>
        <div className="why-choose-card">
          <h3>Easy and Fast Application Process</h3>
          <p>Our online application process is quick and easy, ensuring that you can apply for a loan or investment from the comfort of your home.</p>
        </div>
      </div>
    </section>
  </div>
);

export default Home; 